import React, { useState, useEffect } from 'react';
import { Typography, Form, Input, Upload, Button, InputNumber, Row, Col, Tooltip, message, Spin } from 'antd';
import { createUseStyles } from 'react-jss'

import {CopyToClipboard} from 'react-copy-to-clipboard';

import { UploadOutlined } from '@ant-design/icons';
import Icofont from 'react-icofont';
import { errorCatch, GET } from 'fennec-ui';

const { Title } = Typography;

const useStyles = createUseStyles({
    transfer: {
        '&.ant-transfer': {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
        '&.ant-transfer .ant-transfer-list ': {
            flex: "auto",
            height: "500px",
        }
    }
})

export default function RassilkaText(props) {
    const { auth, object, system } = props;

    const [loading, setLoading] = useState(false);
    const [text, setText] = useState("");

    useEffect(() => {
        setLoading(true)
        GET(auth, `/api/rassilka/get-text/komu-otpravleno/${object.ID}/system/${system}`, ({ data }) => {
            setText(data);
            setLoading(false)
        }, (r, type) => errorCatch(r, type, () => setLoading(false)));
    }, [object, system]);

    return (
        <div>
            <div style={{ padding: "0 0 25px 0", textAlign: "right" }}>
                <CopyToClipboard text={text}
                    onCopy={() => message.success("Скопировано")}>
                    <Button loading={loading} >Скопировать</Button>
                </CopyToClipboard>
            </div>

            {loading && <div style={{ textAlign: "center" }}><Spin size="large" /></div>}
            {!loading && <pre>
                {text}
            </pre>}
        </div>
    );
}
